export const defaultPageSize = '5';
export const defaultPageNo = '1';

export const PLACEHOLDER_TEXT = '_';

export const LAST_UPDATE_DATE_FORMAT = 'dd MMM, YY | hh:mmampm';

export const formatCellData = (value: string | number, symbol = '%') => {
  if (value === '') return PLACEHOLDER_TEXT;
  return `${value}${symbol}`;
};

export const defaultTablePageRequest = {
  size: defaultPageSize,
  page: '1'
};

export const defaultPDPageRequest = {
  agencyPerformance: defaultTablePageRequest,
  agencyInput: defaultTablePageRequest,
  agentPerformance: defaultTablePageRequest,
  agentInput: defaultTablePageRequest
};

export const tableQueryParams = {
  PAGE_NO: 'page',
  PAGE_SIZE: 'size',
  SORT_BY_FIELD: 'sortBy',
  SORT_ORDER: 'sortDirection'
};

export const PDTables = {
  AGENCY_INPUT: 'agencyInput',
  AGENCY_PERFORMANCE: 'agencyPerformance',
  AGENT_INPUT: 'agentInput',
  AGENT_PERFORMANCE: 'agentPerformance'
};

export const PDTablesLabels = {
  [PDTables.AGENCY_INPUT]: 'Agency Input',
  [PDTables.AGENCY_PERFORMANCE]: 'Agency Performance',
  [PDTables.AGENT_INPUT]: 'Agent Input',
  [PDTables.AGENT_PERFORMANCE]: 'Agent Performance'
};

export enum FILTERS {
  DPD_BUCKETS = 'dpdBucket',
  REPORTING = 'agencyCode'
}

export const PDFilters = {
  AGENCY_INPUT: 'agencyInput',
  AGENCY_PERFORMANCE: 'agencyPerformance',
  AGENT_INPUT: 'agentInput',
  AGENT_PERFORMANCE: 'agentPerformance',
  DPD_BUCKETS: {
    label: 'Filter DPD Bucket',
    name: FILTERS.DPD_BUCKETS
  },
  AGENCY_NAME: {
    label: 'Filter agency name',
    name: FILTERS.REPORTING
  }
};

export enum PDView {
  AGENCY_DASHBOARD = 'Agency dashboard',
  AGENT_DASHBOARD = 'Agent dashboard'
}
